import { useState } from "react";
import {
  Box,
  Typography,
  TableCell,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Accordian = ({ result }) => {
  return (
    <TableRow sx={{ backgroundColor: "#f9fafb" }}>
      <TableCell colSpan={Object.keys(result).length}>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={null}>
            <Typography
              sx={{ fontWeight: 500, color: "#111827", width: "60%" }}
            >
              {result.type === "HCO"
                ? result?.Name
                : `${result?.FirstName} ${result?.LastName}`}
            </Typography>
            <Typography sx={{ fontWeight: 500, color: "#111827" }}>
              <span style={{ fontSize: "16px" }} className="title-cs-details">
                {result.Source === "Found in Vendor"
                  ? "One Key ID"
                  : "Enterprise ID"}{" "}
                :{" "}
              </span>{" "}
              {result.type === "HCO"
                ? result?.HCOUniqueId
                : result?.HCPUniqueId}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              {result.Source === "Found in EPH" && (
                <Typography className="title-cs-details">
                  {result.type === "HCO"
                    ? "HCO Reference Id :"
                    : "HCP Reference Id:"}{" "}
                  <span className="details-value-cs">
                    {" "}
                    {result.type === "HCO"
                      ? result?.HCOReferenceId
                      : result?.HCPReferenceId}
                  </span>
                </Typography>
              )}
              {result.type === "HCO" ? (
                <Typography className="title-cs-details">
                  Name :{" "}
                  <span className="details-value-cs">{result?.Name}</span>
                </Typography>
              ) : (
                <>
                  <Typography className="title-cs-details">
                    First Name :{" "}
                    <span className="details-value-cs">
                      {result?.FirstName}
                    </span>
                  </Typography>
                  <Typography className="title-cs-details">
                    Last Name :{" "}
                    <span className="details-value-cs">{result?.LastName}</span>
                  </Typography>
                </>
              )}
              {result?.ClassificationCode && (
                <Typography className="title-cs-details">
                  Classification Code :{" "}
                  <span className="details-value-cs">
                    {result?.ClassificationCode}
                  </span>
                </Typography>
              )}
              <Typography className="title-cs-details">
                Country:{" "}
                <span className="details-value-cs">
                  {result?.Source === "Found in Vendor"
                    ? result?.Country
                    : result?.CountryCode}
                </span>
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        {result?.Specialities?.[0] && (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 500, color: "#111827" }}>
                Specialties
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <Typography className="title-cs-details">
                  Primary Speciality:{" "}
                  <span className="details-value-cs">
                    {sessionStorage.getItem("searchType") === "basic"
                      ? result.Source === "Found in Vendor"
                        ? result?.Specialities?.[0]
                        : result?.Specialities?.[0]
                      : result?.Specialities}
                  </span>
                </Typography>
              </Box>
            </AccordionDetails>
          </Accordion>
        )}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: 500, color: "#111827" }}>
              Address
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <Typography className="title-cs-details">
                Primary Address:{" "}
                <span className="details-value-cs">{result?.Address}</span>
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </TableCell>
    </TableRow>
  );
};

export default Accordian;
